function firstHighest(best, value) {
  return value > best;
}

exports.firstHighest = firstHighest;